package com.xtream.data_kmp.db

 import androidx.room3.migration.Migration
import androidx.sqlite.SQLiteConnection
 import androidx.sqlite.async.executeSQL

object DbMigrations {



                // Migration from version 1 to 2: add TrendingMovies and TrendingTvShows tables
                val MIGRATION_29_30 = object : Migration(29, 30) {
                    override suspend fun migrate(connection: SQLiteConnection) {

                        // Create TrendingMovies table
                        connection.executeSQL(
                            """
                CREATE TABLE IF NOT EXISTS `TrendingMovies` (
                    `adult` INTEGER NOT NULL,
                    `backdrop` TEXT,
                    `id` INTEGER NOT NULL,
                    `name` TEXT NOT NULL,
                    `overview` TEXT NOT NULL,
                    `streamIcon` TEXT,
                    `popularity` REAL,
                    `releaseDate` TEXT NOT NULL,
                    `voteAverage` REAL,
                    `streamId` INTEGER NOT NULL,
                    PRIMARY KEY(`id`)
                )
            """
                        )

                        // Create TrendingTvShows table
                        connection.executeSQL(
                            """
                CREATE TABLE IF NOT EXISTS `TrendingTvShows` (
                    `adult` INTEGER NOT NULL,
                    `backdrop` TEXT,
                    `id` INTEGER NOT NULL,
                    `name` TEXT NOT NULL,
                    `overview` TEXT NOT NULL,
                    `streamIcon` TEXT,
                    `popularity` REAL,
                    `releaseDate` TEXT NOT NULL,
                    `voteAverage` REAL,
                    `streamId` INTEGER NOT NULL,
                    PRIMARY KEY(`id`)
                )
            """
                        )
                    }
                }


    val MIGRATION_30_38 = object : Migration(30, 38) {
        override suspend fun migrate(connection: SQLiteConnection) {

            // Since the tables already exist in the code but the version number
            // needs to jump, we leave this empty.
            // Room will simply update the user_version identity hash in the DB.
        }
    }

    val MIGRATION_38_39 = object : Migration(38, 39) {
        override suspend fun migrate(connection: SQLiteConnection) {

// 1. Create hidden_categories table
            // Note: The primary key is composite, defined at the end of the table creation.
            connection.executeSQL(
                """
            CREATE TABLE IF NOT EXISTS `hidden_categories` (
                `categoryId` INTEGER NOT NULL,
                `type` TEXT NOT NULL,
                `hiddenAt` INTEGER NOT NULL,
                PRIMARY KEY(`categoryId`, `type`)
            )
            """
            )

            // 2. Create live_stream_order table
            // Note: id uses AUTOINCREMENT to match autoGenerate = true
            connection.executeSQL(
                """
            CREATE TABLE IF NOT EXISTS `live_stream_order` (
                `id` INTEGER PRIMARY KEY AUTOINCREMENT NOT NULL,
                `streamId` INTEGER NOT NULL,
                `position` REAL NOT NULL,
                `updatedAt` INTEGER NOT NULL
            )
            """
            )

            // 3. Create the unique index for streamId
            connection.executeSQL(
                "CREATE UNIQUE INDEX IF NOT EXISTS `index_live_stream_order_streamId` ON `live_stream_order` (`streamId`)"
            )

            // 4. Create the standard index for position
            connection.executeSQL(
                "CREATE INDEX IF NOT EXISTS `index_live_stream_order_position` ON `live_stream_order` (`position`)"
            )
             }
    }

    val MIGRATION_39_40 = object : Migration(39, 40) {
        override suspend fun migrate(connection: SQLiteConnection) {

            connection.executeSQL("""
            ALTER TABLE live_stream_order
            ADD COLUMN categoryId INTEGER
        """.trimIndent())

            connection.executeSQL("""
            CREATE INDEX IF NOT EXISTS
            index_live_stream_order_categoryId
            ON live_stream_order(categoryId)
        """.trimIndent())
        }
    }

}